export { default } from './MobileBanner';
